import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../components/MainBody/MainBody";
import MainTabList from "../../components/MainBody/MainTabList";
import { useTrust } from "../../lib/context/TrustContext";
import FAQList from "./FAQList";

const tabsKey = [
  {
    name: "Trust Accounting FAQs",
    tabName: "trust-accounting",
    value: 1,
  },
  {
    name: "AML/CTF FAQs",
    tabName: "aml-ctf",
    value: 2,
  },
];

const FAQTab = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("tab") || "trust-accounting";
  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab,
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);
  const navigate = useNavigate();

  const { trustId } = useTrust();

  useEffect(() => {
    navigate(
      `/faqs?tab=${
        tabsKey?.find((item) => item?.value === activeTab)?.tabName
      }`,
      {
        replace: true,
      },
    );
  }, [activeTab, navigate, trustId]);

  useEffect(() => {
    setActiveTab(tabsKey?.find((item) => item?.tabName === selectedTab)?.value);
  }, [selectedTab]);

  return (
    <>
      <MainBody
        search={false}
        loading={false}
        mainClassName="w-[calc(100%-3rem)]"
        mainTitle={"FAQs"}
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={`bg-background relative sm:max-h-[725px] overflow-auto`}
        >
          {activeTab === 1 ? <FAQList type={1}/> : activeTab === 2 ? <FAQList type={2}/> : ""}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default FAQTab;
